/* eslint-disable no-case-declarations */
import { Map, List } from 'immutable'

import { NEW_MESSAGE, EXPIRE_MESSAGE, CLEAR_ALL_MESSAGE, FILTER_MESSAGE } from '../actions'

export const initialState = new Map({
  messages: new List(),
  count: 0
})

let indexOfListToUpdate = null

const messageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case NEW_MESSAGE:
      const messages = state.get('messages')
      return state
        .set('count', state.get('count') + 1)
        .setIn(['messages'], messages.push(action.data))

    case EXPIRE_MESSAGE:
      indexOfListToUpdate = state
        .get('messages')
        .toJSON()
        .findIndex((message) => message.id === action.data)
      if (indexOfListToUpdate !== -1) {
        return state
          .set('count', state.get('count') - 1)
          .removeIn(['messages', indexOfListToUpdate])
      }
      return state
    case FILTER_MESSAGE:
      const msgs = state
        .get('messages')
        .toJSON()
        .filter((msg) => msg?.code.includes(action.code))
      return state.set('count', msgs.length).setIn(['messages'], new List(msgs))
    case CLEAR_ALL_MESSAGE:
      return state.set('count', 0).setIn(['messages'], new List())

    default:
      return state
  }
}

export default messageReducer
